export default "__VITE_ASSET__DgrFASy2__"